import tw, { styled } from 'twin.macro';

const OneHalfLayout = styled.div`
  ${tw`w-1/2 flex-none`}
`;

export default OneHalfLayout;
